import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18731
 * | Убрать редирект на cloud.mail.ru при попытке открыть раздел "Документы" на b2b
 */
export const ENABLE_ALLDOCUMENTS_FOR_BIZ = getFeature('enable-alldocuments-for-biz') || false;
